'use strict'

export default class DefaultHeader {
    constructor() {
        // JS from here moved to teams repo but class leaved untouched, rm this comment when here will be any change
    }
}
